query GetTeardownTimes {
  teardownTimes {
    id
    label
    duration
  }
}

mutation CreateTeardownTime($id: ID!, $label: String!, $duration: Float!) {
  createTeardownTime(id: $id, label: $label, duration: $duration) {
    teardownTime {
      id
      label
      duration
    }
  }
}

mutation UpdateTeardownTime($id: ID!, $label: String!, $duration: Float!) {
  updateTeardownTime(id: $id, label: $label, duration: $duration) {
    teardownTime {
      id
      label
      duration
    }
  }
}

mutation DeleteTeardownTime($id: ID!) {
  deleteTeardownTime(id: $id) {
    label
    duration
  }
}
